import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { gsap } from 'gsap';

import './style.css';

export default class NgGameRPGEMoveList extends Component {

    state = {
        NowBlock: [],
        nowBlockMoveNumber: 1,
        nowMoveNumber: 1
    }

    // NowBlock, nowBlockMoveNumber
    setBlocks = ({ NowBlock, nowBlockMoveNumber, nowMoveNumber } = {}) => {
        this.setState({ NowBlock, nowBlockMoveNumber, nowMoveNumber })
    }
    setExtras = ({ extras, extrasStrategy } = {}) => {
        this.setState({ extras: [ ...extras ], extrasStrategy: { ...extrasStrategy } })
    }

    render() {

        const { arena: { width: arenaWidth }, zIndex } = this.props;
        const { NowBlock = [], nowMoveNumber } = this.state;

        const allBlocksWidth = arenaWidth * 0.5;

        return <div style={{ zIndex, left: arenaWidth * 0.5, top: arenaWidth * 0.1 }} className='ngg_arena_movelist_container'>
            {NowBlock.map((v, index) => <this.Block key={`ngamlc_${index}`} index={index} allBlocksWidth={allBlocksWidth} />)}
        </div>
    }

    Block = ({ index, allBlocksWidth }) => {
        const { NowBlock, nowBlockMoveNumber, extras, extrasStrategy } = this.state;
        if (!NowBlock || !NowBlock.length || !NowBlock[index]) return null;

        const whosTurn = NowBlock[index]; // 1, 2
        let pastClassname = '';
        let whosClassname = '';
        let thisMoveClassName = '';

        let thisMoveKoef = 1;
        const blockWidth = allBlocksWidth / NowBlock.length;

        if (index < (nowBlockMoveNumber - 1)) pastClassname = 'ngg_arena_movelist_block_past';
        if (whosTurn === 1) whosClassname = 'ngg_arena_movelist_block_player';
        if (whosTurn === 2) whosClassname = 'ngg_arena_movelist_block_snowman';

        if (index === (nowBlockMoveNumber - 1)) {
            thisMoveKoef = 1.2;
            thisMoveClassName = 'ngg_arena_movelist_block_thismove'
        }

        return <div style={{ width: blockWidth * thisMoveKoef, height: blockWidth * thisMoveKoef * 0.22 }} className={`ngg_arena_movelist_block ${pastClassname} ${whosClassname} ${thisMoveClassName}`} >
            {(!!extrasStrategy && !!extrasStrategy[index + 1] && !!extras) && extrasStrategy[index + 1].map(id => {
                const extr = extras.find(x => x.id === id);
                if (!extr || extr.unseen) return null;
                const { type } = extr;
                return <img key={`ebea_${id}`} src={`/../images/ver2/snowman/extras/${type}.png`} />
            })}
        </div>
    }
}